import * as React from 'react';
import { MenuConfig, ToolbarConfig } from '@tencent/workbench';
import { ActionType } from '@editor/src/js/constants/common-action-type';
import i18n from '@i18next/i18n';
import { TOOLBAR_SLIDEBACKGROUND } from '@editor/src/img/pageIndex';
import {
    TDWActionType,
    TDWModuleType,
    TDWOperationType,
} from '@src/slide/infrastructure/module/dependent/report/offline-data-report/constant';

export const config = {
    id: ActionType.CHANGE_BG,
    content: i18n.t('设置背景'),
    icon: TOOLBAR_SLIDEBACKGROUND,
};

export const toolbarConfig = {
    id: ActionType.CHANGE_BG_TOOLBAR,
    content: config.content,
    twdConfig: {
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.BEAUTIFY_TAB,
        action: TDWActionType.BEAUTIFY_BACKGROUND,
        ver3: 1,
    },
};

export const INSERT_TEXT_MENU_CONFIGS: MenuConfig[] = [
    {
        name: config.id,
        content: config.content,
        tooltip: config.content,
        icon: <img src={config.icon} alt={''}/>,
    },
    {
        name: toolbarConfig.id,
        content: '',
    },
];

export const TOOLBAR_ITEMS: ToolbarConfig[] = [
    {
        name: toolbarConfig.id,
        style: {
            width: 'auto',
        },
        icon: <img src={config.icon} />,
        text: toolbarConfig.content,
        tooltip: toolbarConfig.content,
    },
];
